export type HeaderDropdownItem = {
  id?: number;
  link: string;
  text: string;
  alignBottom?: boolean;
  isDisabled?: boolean
  action?: (...args: any[]) => void;
};

export enum MyProfileOptions {
  CHANGE_PLAN = 0,
  PPERSONAL_DETAILS = 1,
  DOCUMENTS,
  REPORTS,
  CHANGE_PASSWORD,
  LOG_OUT,
  PAYOUTS = 6
}
